import React from "react";
import { Grid, Paper, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, Avatar, Divider, Box } from '@mui/material';
import { EmailOutlined, Person, ReceiptOutlined, StoreOutlined } from "@mui/icons-material";
import { withRouter } from "react-router";
import StyledSubHeader from "../../common/StyledSubHeader";
import { getUserObject } from "../../../selectors/UserSelectors";
import IconTextSection from "../../common/IconTextSection";
import { getAllSites } from "../../../selectors/SiteSelectors";
import { TooltipIconButton } from "../../common/StyledButtons";
import Colors from "../../../constants/Colors";
import StyledPage from "../../common/StyledPage";
import StyledSection from "../../common/StyledSection";
import { ICON_TITLE_TEXT_STYLE } from "../../../constants/Styles";

const UserAccountDetails = ({ history }) => {
  const user = getUserObject();
  const sites = getAllSites();

  const renderAccessSection = () => (
    <StyledSection
      title="Business Access"
    >
       <Paper variant='outlined' sx={{ marginTop: '5px', paddingLeft: '10px', paddingRight: '10px', borderRadius: '8px', }}>
        <List style={{ flex: 1 }}>
          {sites && sites.map((site, index) => (
            <ListItem
              dense
              key={user.user_id || user.email}
              sx={{
                backgroundColor: '#fff',
                marginBottom: '5px',
                borderBottom: index !== sites.length - 1 ? '1px solid #e0e0e0' : 'none',
              }}
            >
              <ListItemAvatar>
                {site && site.site_details && site.site_details.site_img_url ?
                  <Avatar alt={site.site_details.site_name} src={site.site_details.site_img_url} />
                  :
                  <Avatar><StoreOutlined /></Avatar>
                }
              </ListItemAvatar>
              <ListItemText
                primary={site.site_details.site_name}
                secondary={site.site_security.primary_user_id === user.user_id ? 'Primary User Access' : 'Standard User'}
              />
              <ListItemSecondaryAction>
                  <TooltipIconButton
                      text={'Go to Business Account'}
                      icon= {<StoreOutlined sx={{ color: Colors.primaryColor }}
                      onClick={() => history.push(`/dashboard/site/${site.site_id}`)}
                  /> } />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
          {(!sites || sites.length === 0) &&
              <p>It doesn't look like you have access to any accounts at this time.</p>
          }
        </List>
      </Paper>
    </StyledSection>
  );

  const renderBillingSection = () => (
    <StyledSection
      title="Looking for Billing?"
    >
      <p>Billing is managed at the Business Account level to keep financial information secure and centralized. Please note that only the primary user of a Business Account can make changes to billing details. If you need to update your billing information, please visit your Business Account to do so.</p>
    </StyledSection>
  )

  const renderOverviewSection = () => (
    <StyledSection
    title="Business Details"
    >
      <Box
        sx={{
          border: '1px solid #ddd',
          borderRadius: '8px',
          padding: 2,
        }}
      >
        <IconTextSection
          icon={<Person sx={{ fontSize: '24px' }} />}
          primaryTextStyle={{ ...ICON_TITLE_TEXT_STYLE }}
          primaryText="Full Name"
          secondaryText={`${user.user_personal.first_name} ${user.user_personal.last_name}`}
        />
        <Divider sx={{ my: 2 }} />
        <IconTextSection
          icon={<EmailOutlined sx={{ fontSize: '24px' }} />}
          primaryTextStyle={{ ...ICON_TITLE_TEXT_STYLE }}
          primaryText="Primary Email"
          secondaryText={user.user_contact.email.primary}
        />
      </Box>
    </StyledSection>
  )

  return (
    <Box sx={{ flexGrow: 1, overflow: 'auto'}}>
      <StyledPage>
        <Grid container>
          <Grid item xs={12}>
            <StyledSubHeader title="My Account" />
          </Grid>
          <Grid item xs={12}>
            {renderOverviewSection()}
          </Grid>
          <Grid item xs={12}>
            {renderAccessSection()}
          </Grid>
          <Grid item xs={12}>
            {renderBillingSection()}
          </Grid>
        </Grid>
      </StyledPage>
    </Box>
    
    
  )
}

export default withRouter(UserAccountDetails);